import { getIntl } from '../i18n/IntlProvider';

// English fallbacks for `apiError.*` codes returned by the backend. The Swedish
// translations live in src/i18n/sv.json under the same keys.
const API_ERROR_DEFAULTS = {
  'apiError.emailDisallowedChars':
    'The email address must not contain disallowed characters (e.g. å, ä, ö)',
};

export const parseError = (e) => {
  const intl = getIntl();
  let translatedMessage = e.data?.message || e.data?.error || null;

  // Translate known apiError.* codes via react-intl
  if (translatedMessage && API_ERROR_DEFAULTS[translatedMessage]) {
    translatedMessage = intl.formatMessage({
      id: translatedMessage,
      defaultMessage: API_ERROR_DEFAULTS[translatedMessage],
    });
  } else if (translatedMessage && /^"([^"]+)"\s(.*)$/.test(translatedMessage)) {
    // Messages starting with a quoted field name (e.g. '"field.name" ...')
    const translation = intl.formatMessage({ id: translatedMessage }, {});

    translatedMessage =
      translation !== translatedMessage
        ? translation
        : intl.formatMessage({ id: 'form.error', defaultMessage: 'Error in form!' });
  }

  return {
    error: {
      status: e.status,
      message: translatedMessage,
      canTryAgain: !translatedMessage,
      timestamp: e.timestamp,
    },
  };
};
